import React, { useEffect, useMemo, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { Page } from "./types";

import { GlobalDataProvider } from '../contexts/GlobalData';
import { UIContextProvider } from '../contexts/UIContext';

import Toasts from '../components_common/Toast/Toast';

import ScrollToTop from "./ScrollToTop";

//import PageHome from "containers/PageHome/PageHome";
import Page404 from "../pages/Page404/Page404";

import useWindowSize from "hooks/useWindowResize";

//import ListingStayDetailPage from "containers/ListingDetailPage/listing-stay-detail/ListingStayDetailPage";
//import ListingCarDetailPage from "containers/ListingDetailPage/listing-car-detail/ListingCarDetailPage";

//import ListingExperiencesDetailPage from "containers/ListingDetailPage/listing-experiences-detail/ListingExperiencesDetailPage";
//import Signup from "pages/Signup/Signup";
//import Login from "pages/Login/Login";
import Home from "pages/Home/Home";
import DetailMotorCycleTours from "pages/DetailMotorCycleTours/DetailMotorCycleTours";


import { requestAPI } from "utils/api";
import Signin from "pages/Signin/Signin";
import Modal from "components_common/Modal/Modal";
//import BottomMenu from "components_custom/BottomMenu/BottomMenu";
import Community from "pages/Community/Community";
import Reservation from "pages/Reservation/Reservation";
import Me from "pages/Me/Me";
import CommunityPost from "pages/Community/CommunityPost";
import CommunityView from "pages/Community/CommunityView";
import ModifyDisplayName from "pages/Me/ModifyDisplayName";
import ModifyName from "pages/Me/ModifyName";

//import ModifyLocation from "pages/Me/ModifyLocation";
import ModifyBirthDate from "pages/Me/ModifyBirthDate";
import ModifyLicense from "pages/Me/ModifyLicense";
import ModifyPhoneNumber from "pages/Me/ModifyPhoneNumber";
import ModifyPassport from "pages/Me/ModifyPassport";
import ModifyResidence from "pages/Me/ModifyResidence";
import ModifyAvatarImg from "pages/Me/ModifyAvatarImg";
import CheckOut from "pages/CheckOut/CheckOut";
import ReservationView from "pages/Reservation/ReservationView";

import ReservationModifyName from "pages/Reservation/ReservationModifyName";
import ReservationModifyBirthDate from "pages/Reservation/ReservationModifyBirthDate";
import ReservationModifyResidence from "pages/Reservation/ReservationModifyResidence";
import ReservationModifyPhoneNumber from "pages/Reservation/ReservationModifyPhoneNumber";
import ReservationModifyEtc from "pages/Reservation/ReservationModifyEtc";
import ReservationModifyPassport from "pages/Reservation/ReservationModifyPassport";
import ReservationModifyLicense from "pages/Reservation/ReservationModifyLicense";
import ReservationModifyEtcFile from "pages/Reservation/ReservationModifyEtcFile";

import Intro from "pages/Intro/Intro";
import RegionCategory from "pages/RegionCategory/RegionCategory";
import ProductMonthlyView from "pages/ProductMonthlyView/ProductMonthlyView";
import Privacy from "pages/Privacy/Privacy";
import Security from "pages/Security/Security";
import ModifyMotorcycles from "pages/Me/ModifyMotorcycles";
import ModifyDrivingExperience from "pages/Me/ModifyDrivingExperience";




export const pages: Page[] = [
	{ path: "/", exact: true, component: Home },
	{ path: "/*", exact: true, component: Home },
	//{ path: "/#", exact: true, component: Home },
	{ path: "/signin", component: Signin },
	// { path: "/signup", component: Signup },
	{ path: "/home", component: Home },
	{ path: "/home/:regionId", component: RegionCategory },
	{ path: "/community", component: Community },
	{ path: "/community-post", component: CommunityPost },
	{ path: "/community-post/:id", component: CommunityPost },
	{ path: "/community/:id", component: CommunityView },
	{ path: "/reservation", component: Reservation },
	{ path: "/reservation/*", component: Reservation },
	{ path: "/reservation/:id", component: ReservationView },
	{ path: "/reservation/:id/*", component: ReservationView },
	{ path: "/reservation/:id/name/:idx", component: ReservationModifyName },
	{ path: "/reservation/:id/birthdate/:idx", component: ReservationModifyBirthDate },
	{ path: "/reservation/:id/residence/:idx", component: ReservationModifyResidence },
	{ path: "/reservation/:id/phonenumber/:idx", component: ReservationModifyPhoneNumber },	
	{ path: "/reservation/:id/etc/:idx", component: ReservationModifyEtc },
	{ path: "/reservation/:id/passport/:idx", component: ReservationModifyPassport },
	{ path: "/reservation/:id/license/:idx", component: ReservationModifyLicense },
	{ path: "/reservation/:id/etcfile/:idx", component: ReservationModifyEtcFile },
	{ path: "/monthly", component: ProductMonthlyView },

	
	
	{ path: "/me", component: Me },
	{ path: "/me/modify-displayname", component: ModifyDisplayName },
	{ path: "/me/modify-name", component: ModifyName },
	{ path: "/me/modify-phonenumber", component: ModifyPhoneNumber },
	{ path: "/me/modify-residence", component: ModifyResidence },
	{ path: "/me/modify-birthdate", component: ModifyBirthDate },
	{ path: "/me/modify-license", component: ModifyLicense },
	{ path: "/me/modify-passport", component: ModifyPassport },
	{ path: "/me/modify-avatarimg", component: ModifyAvatarImg },
	{ path: "/me/modify-motorcycles", component: ModifyMotorcycles },
	{ path: "/me/modify-drivingExperience", component: ModifyDrivingExperience },
	
	
	{ path: "/motorcycle/:id", component: DetailMotorCycleTours }, 

	{ path: "/checkout/:id", component: CheckOut },

	{ path: "/intro", component: Intro },
	{ path: "/privacy", component: Privacy },
	{ path: "/security", component: Security },
];







const MyRoutes = () => {
	
	
	const [initData, setInitData] = useState <any> ({});
	const [isToken, setIsToken] = useState <any> ("");

	useMemo (async () => {
		const res_token: any = await requestAPI ('POST', 'token', {});
		
		
		console.log("token get? ", res_token);
		// console.log(res_init);

		//let localData = localStorage.getItem('authInfo');

		if (res_token.data.token_info.permission_group === "guest") {
			setInitData({
				token: res_token.data.token,
				token_info: res_token.data.token_info,
				userInfo: {}
			});
		} else {
			
			const res_init: any = await requestAPI ('GET', 'v1/init', {});

			setInitData({
				token: res_token.data.token,
				token_info: res_token.data.token_info,
				userInfo: res_init.data.userInfo
			});
		}
		
		setIsToken("1");
	
	}, []);

	

	
	
  	let WIN_WIDTH = useWindowSize().width;
  
	if (typeof window !== "undefined") {
		WIN_WIDTH = WIN_WIDTH || window.innerWidth;
	}

  	if(isToken === "") {
		return (<></>);
	}

	

	return (
		<BrowserRouter>
			<UIContextProvider>
				<GlobalDataProvider _initData={initData}>
					<ScrollToTop />
					<Modal />
					{/* <SiteHeader /> */}
					<Toasts />
					
			

					<Routes>
						
						{pages.map(({ component, path }) => {
							const Component = component;
							return <Route key={path} element={<Component />} path={path} />;
						})}
						
						<Route element={<Page404 />} />
						
					</Routes>

					{/* {WIN_WIDTH < 768 && <FooterNav />} */}
					{/* <Footer /> */}

					

				</GlobalDataProvider>
			</UIContextProvider>
		</BrowserRouter>
	);
};

export default MyRoutes;
